import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { InstitutionGroup } from 'cb-model';
import {
  Display,
  fetchApi,
  FormButtons,
  makeResetCache,
  notify,
  PageTitle,
  QuerySingle,
  Section,
} from 'gossamer-front-end';
import { useDispatch } from 'react-redux';

export const InstitutionGroupDelete = (): React.JSX.Element => {
  const params = useParams();
  const [submitting, setSubmitting] = React.useState<boolean>(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const resetCache = makeResetCache(dispatch);

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      await fetchApi('POST', `/main/institution-group-delete`, {
        institutionGroupId: parseInt(params.key),
      });
      resetCache(InstitutionGroup.id);
      notify(['save successful', 'success']);
      setSubmitting(true);
      navigate('/admin/institution-group/search');
    } catch (e) {
      console.error(e);
      notify(['an error occurred', 'danger']);
    }
  };

  const handleCancel = () => {
    navigate('/admin/institution-group/search');
  };

  return (
    <>
      <PageTitle
        verb="Delete"
        entity={InstitutionGroup}
        keyValue={params.key}
        subtitle="Delete this Group and remove the links to its Events and Members"
      />

      <Section>
        <QuerySingle entity={InstitutionGroup} keyValue={params.key} render={Display} fieldGroup="main" />
      </Section>
      <Section>
        <FormButtons handleSubmit={handleSubmit} handleCancel={handleCancel} submitting={submitting} />
      </Section>
    </>
  );
};
